/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMatchCompetency } from '../fn/match-competency/create-match-competency';
import { CreateMatchCompetency$Params } from '../fn/match-competency/create-match-competency';
import { deleteMatchCompetency } from '../fn/match-competency/delete-match-competency';
import { DeleteMatchCompetency$Params } from '../fn/match-competency/delete-match-competency';
import { getMatchCompetencies } from '../fn/match-competency/get-match-competencies';
import { GetMatchCompetencies$Params } from '../fn/match-competency/get-match-competencies';
import { getMatchCompetency } from '../fn/match-competency/get-match-competency';
import { GetMatchCompetency$Params } from '../fn/match-competency/get-match-competency';
import { MatchCompetency } from '../models/match-competency';
import { MatchCompetencyPagedData } from '../models/match-competency-paged-data';
import { updateMatchCompetency } from '../fn/match-competency/update-match-competency';
import { UpdateMatchCompetency$Params } from '../fn/match-competency/update-match-competency';

@Injectable({ providedIn: 'root' })
export class MatchCompetencyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMatchCompetencies()` */
  static readonly GetMatchCompetenciesPath = '/matchcompetency';

  /**
   * Gets all matching competencies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMatchCompetencies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchCompetencies$Response(params?: GetMatchCompetencies$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetencyPagedData>> {
    const obs = getMatchCompetencies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all matching competencies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMatchCompetencies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchCompetencies(params?: GetMatchCompetencies$Params, context?: HttpContext): Observable<MatchCompetencyPagedData> {
    const resp = this.getMatchCompetencies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchCompetencyPagedData>): MatchCompetencyPagedData => r.body)
    );
  }

  /** Path part for operation `createMatchCompetency()` */
  static readonly CreateMatchCompetencyPath = '/matchcompetency';

  /**
   * Creates a new matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMatchCompetency()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMatchCompetency$Response(params?: CreateMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
    const obs = createMatchCompetency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMatchCompetency$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMatchCompetency(params?: CreateMatchCompetency$Params, context?: HttpContext): Observable<MatchCompetency> {
    const resp = this.createMatchCompetency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchCompetency>): MatchCompetency => r.body)
    );
  }

  /** Path part for operation `getMatchCompetency()` */
  static readonly GetMatchCompetencyPath = '/matchcompetency/{id}';

  /**
   * Gets the specified matching competency.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMatchCompetency()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchCompetency$Response(params: GetMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
    const obs = getMatchCompetency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified matching competency.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMatchCompetency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMatchCompetency(params: GetMatchCompetency$Params, context?: HttpContext): Observable<MatchCompetency> {
    const resp = this.getMatchCompetency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchCompetency>): MatchCompetency => r.body)
    );
  }

  /** Path part for operation `updateMatchCompetency()` */
  static readonly UpdateMatchCompetencyPath = '/matchcompetency/{id}';

  /**
   * Updates the specified matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMatchCompetency()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMatchCompetency$Response(params: UpdateMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
    const obs = updateMatchCompetency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMatchCompetency$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMatchCompetency(params: UpdateMatchCompetency$Params, context?: HttpContext): Observable<MatchCompetency> {
    const resp = this.updateMatchCompetency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MatchCompetency>): MatchCompetency => r.body)
    );
  }

  /** Path part for operation `deleteMatchCompetency()` */
  static readonly DeleteMatchCompetencyPath = '/matchcompetency/{id}';

  /**
   * Deletes the specified matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMatchCompetency()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMatchCompetency$Response(params: DeleteMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMatchCompetency(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified matching competency [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMatchCompetency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMatchCompetency(params: DeleteMatchCompetency$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteMatchCompetency$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
